module.exports = __webpack_public_path__ + "static/media/WorkAccident.f06cabb6.svg";